import React from 'react'
import { WeekdayProps } from 'react-day-picker'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { getReadableShortWeekdayName } from '../../constants'

export function WeekdayUi(props: WeekdayProps) {
  const { t } = useTypedTranslation()

  return (
    // @ts-expect-error: ask Kamol
    <th ref={props.ref as any} {...props}>
      {t(getReadableShortWeekdayName(Number(props['aria-label'])))}
    </th>
  )
}
